/**
 * Datum/Zeit-Formatierung für den HypeFly-Admin.
 *
 * Warum diese Helfer?
 *  - `Date.toLocaleString('de-DE')` OHNE `timeZone`-Option nutzt die
 *    Browser-lokale Zeitzone. In gehosteten Preview-Umgebungen (Docker /
 *    Kubernetes-Node) ist das oft UTC → Anzeige liegt 1–2 Stunden daneben.
 *  - Mit `timeZone: 'Europe/Berlin'` bekommt der Admin unabhängig vom
 *    Rechner immer die deutsche Wanduhr-Zeit, DST-korrekt (CET ↔ CEST).
 *  - Kein neuer Formatter — wir bleiben bei `Intl.DateTimeFormat`, das
 *    Browser hat es nativ, keine Bundle-Bloat.
 */

const BERLIN = "Europe/Berlin";
const LOCALE = "de-DE";

function _toDate(input: string | Date | null | undefined): Date | null {
    if (!input) return null;
    let d: Date;
    if (typeof input === "string") {
        // Defensiv: MongoDB liefert `datetime` teils als NAIVE UTC ohne
        // TZ-Suffix zurück. JS würde das als LOKAL-Zeit parsen und die
        // Anzeige würde in die falsche Zeitzone rutschen. Wenn kein Z
        // und kein ±HH:MM-Suffix vorhanden ist, expliziten `Z` anhängen.
        const s = input.trim();
        const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(s);
        d = new Date(hasTz ? s : `${s}Z`);
    } else {
        d = input;
    }
    return isNaN(d.getTime()) ? null : d;
}

/** Datum + Uhrzeit, deutsche Wanduhr-Zeit. Beispiel: `04.08.2026, 11:43`. */
export function fmtDateTime(
    input: string | Date | null | undefined,
    opts?: Intl.DateTimeFormatOptions,
): string {
    const d = _toDate(input);
    if (!d) return "";
    return d.toLocaleString(LOCALE, { timeZone: BERLIN, ...(opts || {}) });
}

/** Nur Datum, deutsche Wanduhr-Zeit. Beispiel: `04.08.2026`. */
export function fmtDate(
    input: string | Date | null | undefined,
    opts?: Intl.DateTimeFormatOptions,
): string {
    const d = _toDate(input);
    if (!d) return "";
    return d.toLocaleDateString(LOCALE, { timeZone: BERLIN, ...(opts || {}) });
}

/** Nur Uhrzeit, deutsche Wanduhr-Zeit. Beispiel: `11:43:07`. */
export function fmtTime(
    input: string | Date | null | undefined,
    opts?: Intl.DateTimeFormatOptions,
): string {
    const d = _toDate(input);
    if (!d) return "";
    return d.toLocaleTimeString(LOCALE, { timeZone: BERLIN, ...(opts || {}) });
}
